module.exports = __webpack_public_path__ + "static/img/goldBall.47ab774.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/goldBall.png
// module id = 9hiz
// module chunks = 1